<template>
  <!-- 合作伙伴 -->
  <div class="container info-operation" ref="dom">
    <div
      class="introduce-container operation-ind pi-pd-bottom-68"
      style="max-width: 1170px"
    >
      <div class="pi-fz-30 pi-fw-900 pi-mg-bottom-22">
        携手同行 · 共建合作伙伴生态
      </div>
      <div class="content">
        <p style="text-align: center pi-fz-16 pi-fw-400">
          我们始终秉持以客户为中心的合作理念，以技术合作和人才培养为支撑，携手合作伙伴，打造生机勃勃的合作生态。
        </p>
      </div>
    </div>
    <el-carousel
    :class="isMobile||show ? 'animate__animated animate__fadeIn' : 'hide'"
      ref="cooperatorCarousel"
      :interval="3000"
      height="200px"
      indicator-position="none"
      style="width: 100%"
      class="cooperator-carousel"
    >
      <el-carousel-item
        height="200px"
        v-for="(pItem, pIndex) in cooperators"
        :key="'pindex-' + pIndex"
        class="cooperator-carousel-item"
      >
        <div class="operation-tabs">
          <div
            class="operation-tab-item"
            v-for="(item, index) in pItem"
            :key="index"
          >
            <el-image :src="item.img" fit="contain"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import data from "../../data";
import { isMobile } from "@/utils";
import { slicingArray, numberFormat } from "@/utils";
export default {
  data() {
    return {
      isMobile: isMobile(),
      cooperators: slicingArray(data.cooperator, 4, 4),
    };
  },
   model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    loadInit() {
      return this.$refs.dom;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-operation {
  width: 100%;
  padding: 0 160px 160px;
  padding-top: 81px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .cooperator-carousel {
    .cooperator-carousel-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .operation-tabs {
        margin: 0 -10px;
        width: calc(100% + 20px);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .operation-tab-item {
          width: calc(25% - 20px);
          margin: 0 10px;
          border: 1px solid #f5f5f5;

          .el-image {
            width: 100%;
            height: 180px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/row_7/index.vue